// src/components/site-editor/panels/HeroBackgroundPanel.js
import React from 'react';
import { useWebsiteBuilder } from '../../../contexts/WebsiteBuilderContext';
import HeroSettings from '../../editors/HeroSettings';

const HeroBackgroundPanel = () => {
  const { state, actions } = useWebsiteBuilder();
  const { draft } = state;

  const handleHeroUpdate = (updatedHero) => {
    // HeroSettings returns the full updated hero object
    // We need to update each field individually for the context
    Object.keys(updatedHero).forEach((key) => {
      actions.updateHero(key, updatedHero[key]);
    });
  };

  const currentColors = draft.design.customColors || {
    primary: '#7C3AED',
    secondary: '#FCD34D',
    background: '#FFFFFF',
    text: '#1F2937',
    accent: '#EC4899'
  };

  return (
    <div className="p-6 space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-slate-900 mb-1">Hero Background</h3>
        <p className="text-sm text-slate-600">Customize the top section of your website</p>
      </div>

      {/* Reuse HeroSettings from wizard */}
      <HeroSettings
        heroSettings={draft.hero}
        onUpdate={handleHeroUpdate}
        colors={currentColors}
        showTextAlignment={false}
      />
    </div>
  );
};

export default HeroBackgroundPanel;
